import { render } from "./TransferPatientForm.vue?vue&type=template&id=562c5bf3"
import script from "./TransferPatientForm.ts?vue&type=script&lang=js&external"
export * from "./TransferPatientForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__